import React from 'react';
import { Icon } from './Icon';

const TotalViewsIcon = ({ size }: Props) => {
  return (
    <Icon type="polygon" color="bg-label-primary" size={size} />
  );
}

interface Props {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}

export { TotalViewsIcon };